<template>
  <PageTitle title="Создание инициативы о применении мер таможенно-тарифного регулирования" miniIndentation />

  <div v-if="isAccessAllowed" class="container-page big">
    <TabStep
      :components="components"
      confirmButton="Создать заявление"
      :cancelRoute="{ name: 'RequestInitiativeTtrRegistry' }"
      @step="scrollTop"
    />
  </div>
</template>

<script>
  import { defineComponent } from 'vue';

  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import TabStep from '@/common/components/redesigned/Tabs/TabsSteps/TabStep.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';

  import InitiativeJustificationMeasure from '../components/initiativeComponents/initiativeForm/InitiativeJustificationMeasure.vue';
  import InitiativeMainInfo from '../components/initiativeComponents/initiativeForm/InitiativeMainInfo.vue';
  import InitiativeRate from '../components/initiativeComponents/initiativeForm/initiativeRate/InitiativeRate.vue';

  const PERMISSIONS = {
    create: Constants.Permissions.RequestInitiativeTtrCreateAdmin,
  };

  export default {
    name: 'RequestInitiativeTtrCardAdd',
    components: {
      PageTitle,
      TabStep,
    },
    mixins: [security],
    data() {
      return {
        components: [
          {
            component: defineComponent(InitiativeMainInfo),
            props: { tabTitle: 'Основная информация' },
          },
          {
            component: defineComponent(InitiativeRate),
            props: { tabTitle: 'Ставки' },
          },
          {
            component: defineComponent(InitiativeJustificationMeasure),
            props: { tabTitle: 'Обоснование предлагаемой меры' },
          },
        ],
      };
    },
    async created() {
      await this.checkPermissionAndRedirect(PERMISSIONS.create);
    },
    methods: {
      scrollTop() {
        Utils.windowTop();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
